import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'ProfileRewards'
}

export const fetchProfileRewardsData = new Action('fetchProfileRewardsData', {
  init: (answerSource, callback) => ({ answerSource, callback }),
  success: (data) => data,
})

export const updateProfileRewardsAnswer = new Action('updateProfileRewardsAnswer', {
  init: (questionId, answerText, selectedChoiceIds, callback) => ({
    questionId,
    answerText,
    selectedChoiceIds,
    callback,
  }),
  success: (question) => ({ question }),
})

const fetchFullUnveil = new Action('fetchFullUnveil', {
  init: (callback) => ({ callback }),
  success: (attributesCount, profilesCount, questions, associatedIds, conflicts, breachData) => ({
    attributesCount,
    profilesCount,
    questions,
    associatedIds,
    conflicts,
    breachData,
  }),
})

const updateFullUnveil = new Action('updateFullUnveil', {
  init: (withConflictResolution, isSkipped, callback) => ({ withConflictResolution, isSkipped, callback }),
})

const resetFullUnveil = new Action('resetFullUnveil', {
  success: () => {},
})

const toggleAssociatedIdIsHidden = new Action('toggleAssociatedIdIsHidden', {
  success: (associatedIdIndex) => ({ associatedIdIndex }),
})

const updateAssociatedIds = new Action('updateAssociatedIds', {
  init: (isAllHidden, callback) => ({ isAllHidden, callback }),
})

const setFullUnveilConflictSelectedOption = new Action('setFullUnveilConflictSelectedOption', {
  success: (questionIndex, selectedOptionIndex) => ({ questionIndex, selectedOptionIndex }),
})

const fetchBreachData = new Action('fetchBreachData', {
  init: (callback) => ({ callback }),
  success: (breachesCount, passwordsCount, breachesAttributesCount, isDataBreachesScanned, idBreaches) => ({
    breachesCount,
    passwordsCount,
    breachesAttributesCount,
    isDataBreachesScanned,
    idBreaches,
  }),
})

const fetchUnveilNotificationSummary = new Action('fetchUnveilNotificationSummary', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

export default {
  fetchProfileRewardsData,
  updateProfileRewardsAnswer,
  fetchFullUnveil,
  updateFullUnveil,
  resetFullUnveil,
  toggleAssociatedIdIsHidden,
  updateAssociatedIds,
  setFullUnveilConflictSelectedOption,
  fetchBreachData,
  fetchUnveilNotificationSummary,
}
